
import { ComponentNode } from '../nodes/ComponentNode';
import { LabeledGroupNode } from '../nodes/LabeledGroupNode';
import { TextNode } from '../nodes/TextNode';
import { ActorNode } from '../nodes/ActorNode';
import { ImageNode } from '../nodes/ImageNode';
import { NodeTypes } from '@xyflow/react';

// Helper function to generate UUID
export function generateUUID() {
  return crypto.randomUUID ? 
    crypto.randomUUID() : 
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

// Define node types
export const nodeTypes: NodeTypes = {
  componentNode: ComponentNode,
  labeledGroup: LabeledGroupNode,
  textNode: TextNode,
  actorNode: ActorNode,
  imageNode: ImageNode
};
